module.exports = __webpack_public_path__ + "static/media/acerta-vest.7fb3447c.svg";